import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * The one toast style for the whole site (Ray 2026-10-26): compact, modern,
 * bottom-centre — never over the top-right header where the close button and
 * the profile live. Tap a toast to dismiss it; at most 3 on screen; newest on
 * top. On phones it sits just above the bottom menu.
 */
const BOTTOM_NAV = 64; // SideNav's phone bar

const ToastStyle = createGlobalStyle`
  :root {
    --toastify-toast-min-height: 40px;
    --toastify-toast-max-height: 240px;
    --toastify-toast-padding: 8px 14px;
    --toastify-toast-bd-radius: 12px;
    --toastify-container-width: min(420px, calc(100vw - 32px));
    --toastify-font-family: inherit;
    --toastify-toast-offset: 20px;
    --toastify-color-light: var(--app-surface-elevated, #fff);
    --toastify-text-color-light: var(--app-text, #1d1d1f);
    --toastify-color-dark: var(--app-surface-elevated, #1e2350);
    --toastify-text-color-dark: var(--app-text, #fff);
  }
  .Toastify__toast-container--bottom-center {
    bottom: var(--toastify-toast-offset);
    left: 50%;
    transform: translateX(-50%);
    width: var(--toastify-container-width);
    padding: 0;
  }
  @media (max-width: 768px) {
    .Toastify__toast-container--bottom-center {
      bottom: calc(${BOTTOM_NAV}px + 12px + env(safe-area-inset-bottom, 0px));
    }
  }
  .Toastify__toast {
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 1.35;
    font-weight: 500;
    border: 1px solid var(--app-border, rgba(0, 0, 0, 0.08));
    box-shadow: 0 8px 24px var(--app-shadow, rgba(0, 0, 0, 0.12));
    cursor: pointer;
  }
  .Toastify__toast-body { padding: 0; gap: 8px; }
  .Toastify__toast-icon { width: 16px; }
  .Toastify__close-button { display: none; }
`;

export default function AppToasts() {
   return (
      <>
         <ToastStyle />
         <ToastContainer
            position="bottom-center"
            autoClose={3000}
            limit={3}
            newestOnTop
            closeOnClick
            closeButton={false}
            hideProgressBar
            draggable
            transition={Slide}
            theme="light"
            className="sf-toasts"
         />
      </>
   );
}
